// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3Jvd-","visuallyhidden":"_2lClt","hide-text":"p57qh","center":"_3QjKN","noprint":"_JFyy","top_object":"_1GXzR","top-object-in-header":"NRL-4"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-top-object/styles/default.scss
 ** module id = 1025
 ** module chunks = 2
 **/